import { lazy, type LazyExoticComponent, type ComponentType } from "react";

// ---------------------------------------------------------------------------
// Navegación de la app «Movik» (categoría B2C). Alimenta el sub-menú
// (MovikLayout), las rutas (routes.tsx) y el evento `b2c_movik_vista` por
// sección. Los ids son las llaves `menu:movik.<id>` del catálogo de derechos y
// del preset de cada tenant (`b2c.movik.menu`). `marca` es la vista de sólo
// lectura que antes era la app Movik de Sistemas Internos (#1535).
//
// Las secciones se cargan bajo demanda: es un panel interno de operación y no
// debe viajar en el bundle de todos los usuarios.
// ---------------------------------------------------------------------------

export const MOVIK_BASE = "/b2c/movik";

export type MovikSectionId = "resumen" | "personas" | "acompanamientos" | "sos" | "marca" | "web";

export interface MovikNavItem {
  id: MovikSectionId;
  labelKey: string;
  icon: string;
  element: LazyExoticComponent<ComponentType>;
}

export const MENU: MovikNavItem[] = [
  { id: "resumen", labelKey: "b2cMovik.menu.resumen", icon: "ri-dashboard-line", element: lazy(() => import("../../pages/b2c/movik/ResumenSection")) },
  { id: "personas", labelKey: "b2cMovik.menu.personas", icon: "ri-group-line", element: lazy(() => import("../../pages/b2c/movik/PersonasSection")) },
  { id: "acompanamientos", labelKey: "b2cMovik.menu.acompanamientos", icon: "ri-walk-line", element: lazy(() => import("../../pages/b2c/movik/AcompanamientosSection")) },
  { id: "sos", labelKey: "b2cMovik.menu.sos", icon: "ri-alarm-warning-line", element: lazy(() => import("../../pages/b2c/movik/SosSection")) },
  { id: "marca", labelKey: "b2cMovik.menu.marca", icon: "ri-user-add-line", element: lazy(() => import("../../pages/b2c/movik/MarcaSection")) },
  { id: "web", labelKey: "b2cMovik.menu.web", icon: "ri-global-line", element: lazy(() => import("../../pages/b2c/movik/WebSection")) },
];

export const movikDefaultRoute = `${MOVIK_BASE}/${MENU[0].id}`;

export const movikSectionPath = (id: MovikSectionId) => `${MOVIK_BASE}/${id}`;

/** Sección a la que apunta una ruta, o `null`. */
export function movikSectionOf(pathname: string): MovikSectionId | null {
  const match = MENU.find((item) => pathname === movikSectionPath(item.id) || pathname.startsWith(`${movikSectionPath(item.id)}/`));
  return match ? match.id : null;
}
